// Libraries
import { Grid, Skeleton, Stack } from "@mui/material";

// Components
import DatePickerRangeSkeleton from "./DatePickerRangeSkeleton";
import TableLoader from "@/Layouts/components/Skeletons/TableLoader";

export default function SocialMediaReviewAssociateTableSkeleton() {
	return (
		<Stack width={"100%"}>
			<Skeleton variant="rectangular" height={25} width={150} className="rounded-md mt-2" />
			<DatePickerRangeSkeleton />
			<Grid container item mt={-7} rowSpacing={1} columnSpacing={0} mb={2}>
				<Grid item xs={12}>
					<TableLoader content rows={10} toolbar buttons={2} />
				</Grid>
			</Grid>
		</Stack>
	);
}
